var TEST_ID_ATTRIBUTE = 'data-testid';
export var pickTestId = function pickTestId() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return props[TEST_ID_ATTRIBUTE] || props.id;
};